<template><SimpleModuleDashboard :module-id="Modules.INFORME_GENERAL" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    dashboardActions() {
      return Helper.getSeller()
        ? [{ id: 'crudReportSeller', reference: 'crudReportSeller', route: 'ReportsGeneralStaffCrudReportSeller', tone: 'primary' }]
        : [{ id: 'crudReport', reference: 'crudReport', route: 'ReportsGeneralStaffCrudReport', tone: 'primary' }]
    },
  },
}
</script>
